import { render, staticRenderFns } from "./IconBlock.vue?vue&type=template&id=1e09853a&scoped=true&"
import script from "./IconBlock.vue?vue&type=script&lang=js&"
export * from "./IconBlock.vue?vue&type=script&lang=js&"
import style0 from "./IconBlock.vue?vue&type=style&index=0&id=1e09853a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e09853a",
  null
  
)

export default component.exports